export default {
    "de": {
        "licenseid": "Lernfahrausweis ID *",
        "licenseid.hint": "Für ZH & AG die Nummer im Adressfeld, andere Kantone Faber oder Reg-Nr",
        "birthdate": "Geburtsdatum *",
        "name": "Vorname, Name *",
        "phone": "Telefon *",
        "street": "Strasse, Nr. *",
        "city": "PLZ, Ort *",
        "ondemand": "Kurstag ändern",
        "ondemand.hint": "Falls dir einer der Termine nicht passen sollte, bitten wir dich, das Datum hier zu notieren.",
        "comments": "Bemerkungen",
        "agb": "Ich akzeptiere die ",
        "part1": "Teil 1",
        "part2": "Teil 2",
        "part2a": "Teil 2a",
        "part3": "Teil 3",
        "part4": "Teil 4",
        "freeplaces": "Freie Plätze",
        "choose": "Kurs auswählen...",
        "error.badreq": "Bitte füllen Sie alle mit * gekennzeichneten Felder aus.",
        "error.notfound": "ANMELDUNG ABGEBROCHEN: Ihre Daten wurden nicht gefunden, bitte überprüfen Sie die Lernfahrausweis-Nummer.",
        "error.mismatch": "ANMELDUNG ABGEBROCHEN: Lernfahrausweis ID und Geburtsdatum stimmen nicht überein.",
        "error.dupe": "ANMELDUNG ABGEBROCHEN: Sie wurden schon für diesen Kurs angemeldet.",
        "error.late": "ANMELDUNG ABGEBROCHEN: Ihre Lernfahrausweis ID ist für diesen Kurs nicht mehr gültig.",
        "error.invalid": "Bitte gültige Kursdaten auswählen.",
        "error.prefix": "ANMELDUNG ABGEBROCHEN: ",
        "title.dates": "Kursdaten",
        "title.change": "Kurstag ändern (nur ein Tag möglich)",
        "title.contact": "Kontaktdaten",
        "signup": "Jetzt Anmelden",
        "pleasewait": "Bitte warten...",
        "email": "E-Mail *",
        "noselection": "Keine",
        "title.signup": "Anmeldung zum Kurs",
        "subtitle.signup": "Bitte auswählen",
        "nocourses": "Zurzeit sind keine Kurse Verfügbar",
        "rentscooter": "Rollermiete",
        "rentmotorcycle": "Motorradmiete",
        "location": "Lokation",
        "spamnote": "Wenn Du kein Bestätigungsmail erhalten hast, schau bitte kurz im Spam bzw. Junk-Mail Ordner nach und falls es dort ebenfalls unauffindbar ist, dann schreib uns an"
    },
    "en": {
        "licenseid": "Learner permit number *",
        "licenseid.hint": "For ZH & AG the number in the address field, other cantons Faber or Reg-No.",
        "birthdate": "Birthday *",
        "name": "Full name *",
        "phone": "Phone *",
        "street": "Street, house number *",
        "city": "City, postal code *",
        "ondemand": "Change dates",
        "ondemand.hint": "If one of the dates does not suit you, please note the date here.",
        "comments": "Message",
        "agb": "I accept the ",
        "part1": "Part 1",
        "part2": "Part 2",
        "part2a": "Part 2a",
        "part3": "Part 3",
        "part4": "Part 4",
        "freeplaces": "Available spots",
        "choose": "Please select...",
        "error.badreq": "Please fill out all fields marked with *",
        "error.notfound": "REGISTRATION CANCELLED: Your data could not be found, please check the learner license number.",
        "error.mismatch": "REGISTRATION CANCELLED: Learner license ID and date of birth do not match.",
        "error.dupe": "REGISTRATION CANCELLED: You have already been registered for this course.",
        "error.late": "REGISTRATION CANCELLED: Your learner license ID is no longer valid for this course.",
        "error.prefix": "REGISTRATION CANCELLED: ",
        "error.invalid": "Please select a valid course combination.",
        "title.dates": "Course dates",
        "title.change": "Change date (only one possible)",
        "title.contact": "Contact details",
        "signup": "Send request",
        "pleasewait": "Please wait...",
        "email": "Email *",
        "noselection": "None",
        "title.signup": "Sign up for courses",
        "subtitle.signup": "Please select an option",
        "nocourses": "No courses available at the moment",
        "rentscooter": "Rent a scooter",
        "rentmotorcycle": "Rent a motorcycle",
        "location": "Location",
        "spamnote": "If you have not received a confirmation email, please have a quick look in your spam or junk mail folder and if you cannot find it there either, please write to us at"
    }
};